// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-1[data-v-0a6b4c1e] {\n  padding: 0 5px;\n}\n.table-2[data-v-0a6b4c1e] {\n  padding: 0 10px;\n}\n.table-3[data-v-0a6b4c1e] {\n  padding: 0 15px;\n}\n", ""]);
// Exports
module.exports = exports;
